import { useCallback } from 'react';

import { downloadFile } from '@cast/utils';

import { WorkloadDataTransfer } from '../../_types';
import { prepareDataFormExport } from '../_utils';

type UseReportDownload = {
  download: () => void;
};

export const useReportDownload = (
  filename: string,
  data: WorkloadDataTransfer[]
): UseReportDownload => {
  const download = useCallback(() => {
    downloadFile(prepareDataFormExport(data), `${filename}.csv`);
  }, [data, filename]);

  return { download };
};
